import type { AppDataState } from "../api/useAppData";

export default function SimulationBanner({ state }: { state: AppDataState }) {
  const sentinel = state.data?.debug?.simulationSentinel;
  const expired = state.data?.debug?.simulationExpired;
  if (!sentinel) return null;

  const firstColon = sentinel.indexOf(":");
  const secondColon = sentinel.indexOf(":", firstColon + 1);
  const seed = firstColon >= 0 ? sentinel.slice(0, firstColon) : sentinel;
  const preset =
    firstColon >= 0 && secondColon > firstColon
      ? sentinel.slice(firstColon + 1, secondColon)
      : "?";
  const generatedAt = secondColon > 0 ? sentinel.slice(secondColon + 1) : null;
  const parsed = generatedAt ? new Date(generatedAt) : null;
  const when =
    parsed && !Number.isNaN(parsed.getTime())
      ? parsed.toLocaleString()
      : "unknown time";

  if (expired) {
    return (
      <div className="banner error" role="alert">
        <strong>SIMULATION EXPIRED</strong> — clear before tournament starts.
        Demo seed <code>{seed}</code>, preset <code>{preset}</code>, generated{" "}
        {when}.
      </div>
    );
  }

  return (
    <div className="banner warn" role="status">
      <strong>SIMULATED DATA</strong> — seed <code>{seed}</code>, preset{" "}
      <code>{preset}</code>, generated {when}. Run{" "}
      <code>npm run sim:clear</code> to revert.
    </div>
  );
}
